import { ComponentType, Indicator } from '@/models'
import asyncImport from '@/utils/client/asyncImport'

export const indicators = {
  name: 'indicator',
  namespace: 'indicators',
  title: 'Indicadores',
  titleSingle: 'Indicador',
  description: 'Realiza cálculos y otras operaciones',
  icon: 'subtitles',
  color: 'cyan',
  overview: 'Los indicadores son elementos que muestran información dentro de su proyecto CODELESS. Úselas para mostrar información como la fecha dentro de sus proyectos.',

  queryName: 'indicators',
  queryFields: `{
    _id
    name
    title
    indicatorTypeId
  }`,
  searchable: true,

  transformResult: (indicator) => ({
    ...indicator,
    name: indicator.name,
    title: indicator.name,
    subtitle: indicator.indicatorTypeId,
    href: `indicators/${indicator._id}`
  }),

  viewSkeleton: 'card-heading, text',

  create: () => asyncImport(import('./Create.vue')),
  list: () => asyncImport(import('./List.vue')),
  view: () => asyncImport(import('./View.vue')),
  edit: () => asyncImport(import('./Edit.vue'))
} as ComponentType<Indicator>
